export function addSuffix(num: number | string): string {
  if (Number(num) < 100000) {
    return num.toString()
  }

  const suffixes = ['', 'K', 'KK', 'B']
  const index = Math.floor(Math.log10(Number(num)) / 3)
  const formattedNumber = Math.floor(Number(num) / Math.pow(1000, index))

  return `${formattedNumber}${suffixes[index]}`
}
